import { render, staticRenderFns } from "./Recapulation.vue?vue&type=template&id=d3f8d994&scoped=true"
import script from "./Recapulation.vue?vue&type=script&lang=js"
export * from "./Recapulation.vue?vue&type=script&lang=js"
import style0 from "./Recapulation.vue?vue&type=style&index=0&id=d3f8d994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f8d994",
  null
  
)

export default component.exports